import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './QuizView.module.scss'

const QuizHeader = ({ item, index, showCounter }) => {
  const { t } = useTranslation()
  const { quiz, sectionIndex, final } = item
  const number = sectionIndex + 1

  return (
    <div className={classNames('d-flex align-items-start justify-content-between flex-wrap', classes.head)}>
      <div>
        <span className={classes.eyebrow}>
          {t(final ? 'portal.certification.quiz.eyebrowFinal' : 'portal.certification.quiz.eyebrowSection', { number })}
        </span>
        <h1 className={classes.title}>
          {t(final ? 'portal.certification.item.finalExam' : 'portal.certification.item.sectionQuiz', { number })}
        </h1>
      </div>
      {showCounter && quiz.questions.length > 0 && (
        <div className='text-right'>
          <div className={classes.counter}>{t('portal.certification.quiz.question', { current: index + 1, total: quiz.questions.length })}</div>
          <div className={classes.passLine}>
            {t('portal.certification.quiz.passLine', { passMark: quiz.passMark })}
            {' · '}
            {quiz.attemptsLeft === null
              ? t('portal.certification.quiz.unlimitedRetakes')
              : t('portal.certification.quiz.attemptsLeft', { count: quiz.attemptsLeft })}
          </div>
        </div>
      )}
    </div>
  )
}

QuizHeader.propTypes = {
  item: PropTypes.shape({
    sectionIndex: PropTypes.number.isRequired,
    final: PropTypes.bool.isRequired,
    quiz: PropTypes.shape({
      passMark: PropTypes.number.isRequired,
      attemptsLeft: PropTypes.number,
      questions: PropTypes.array.isRequired,
    }).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  showCounter: PropTypes.bool.isRequired,
}

export default QuizHeader
